export const getVideoAssetThumbnails = (videoAssetData) => {
  const videoThumbnailArr = videoAssetData?.data?.attributes?.data?.thumbnails || []
  const filteredThumbnailArr = videoThumbnailArr?.filter(thumb => thumb && thumb?.width >= 300)
  const videoThumbnailWeb = filteredThumbnailArr?.[filteredThumbnailArr.length - 1]?.link || ''
  const videoThumbnailMobile = filteredThumbnailArr?.[0]?.link || ''

  return { videoThumbnailWeb, videoThumbnailMobile }
}

export const getVideoAssetStreamData = (videoAssetData) => {
  const videoData = videoAssetData?.data?.attributes?.data || {}
  const platform = videoAssetData?.data?.attributes?.platform
  return { videoData, platform }
}
